export default "__VITE_ASSET__B_h2FiY___"